export default function equalsTo(value, valueToCompare) {
  return value === valueToCompare;
}
